"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizableCheckmark = void 0;
var CustomizableCheckmark_1 = require("./CustomizableCheckmark");
Object.defineProperty(exports, "CustomizableCheckmark", { enumerable: true, get: function () { return CustomizableCheckmark_1.CustomizableCheckmark; } });
//# sourceMappingURL=index.js.map